import { AnyAction } from 'redux';

import { Account } from '../../../common/models/account';
import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';
import { DASHBOARD_REQUEST_END, DASHBOARD_REQUEST_START } from './dashboard-actions';
import { Supplier } from '../../../common/models/supplier';

export interface DashboardReducerState {
    customerNameCache: Customer[];
    accountNameCache: Account[];
    customerContactNameCache: Contact[];
    supplierNameCache: Supplier[];
    requesting: boolean;
}

const initialDashboardReducerState: DashboardReducerState = {
    customerNameCache: [],
    accountNameCache: [],
    customerContactNameCache: [],
    supplierNameCache: [],
    requesting: false,
};

export const dashboardReducer = (
    state: DashboardReducerState = initialDashboardReducerState,
    action: AnyAction
): DashboardReducerState => {
    const { type } = action;
    switch (type) {
        case DASHBOARD_REQUEST_START: {
            return {
                ...state,
                requesting: true,
            };
        }

        case DASHBOARD_REQUEST_END: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
